import { createRouter, createWebHistory } from "vue-router";
import routesNames from './routesNames';
import { useProgressBarLoading } from "@/composition/progress-bar-loading"

const { useComponentChunkWithProgressBar } = useProgressBarLoading();

const Calendar = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "calendar" */ "@/views/calendar/Calendar.vue"));
}

const Collections = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "collections" */ "@/views/collections/Collections.vue"));
}

const Pulse = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "pulse" */ "@/views/Pulse.vue"));
}

const Crates = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "crates" */ "@/views/Crates.vue"));
}

const Alerts = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "alerts" */ "@/views/Alerts.vue"));
}

const DiscordHook = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "discord-hook" */ "@/views/DiscordHook.vue"));
}

const SingleCollection = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "single-collections" */ "@/views/collections/SingleCollection.vue"));
}

const SingleWallet = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "single-wallet" */ "@/views/wallet/SingleWallet.vue"));
}

const FavoriteWallets = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "favorite-wallets" */ "@/views/wallet/FavoriteWallets.vue"));
}

const Settings = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "settings" */ "@/views/settings/Settings.vue"));
}

const ApiTokens = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "api-tokens" */ "@/views/settings/ApiTokens.vue"));
}

const LinkedWallets = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "linked-wallets" */ "@/views/settings/LinkedWallets.vue"));
}

const BillingInfo = () => {
  const { useComponentChunkWithProgressBar } = useProgressBarLoading();
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName: "billing-info" */ "@/views/settings/BillingInfo.vue"));
}

const CalendarItem = () => {
  return useComponentChunkWithProgressBar(() => import(/* webpackChunkName "collection-item" */ "@/views/calendar-item/CalendarItem.vue"));
}


const routes = [
  {
    path: '/',
    redirect: '/app',
  },
  {
    path: '/app',
    redirect: '/collections/trending',
  },
  {
    path: '/calendar',
    name: routesNames.calendar,
    component: Calendar,
  },
  {
    path: '/calendar/:itemId',
    props: true,
    name: routesNames.calendarItem,
    component: CalendarItem,
  },
  {
    path: '/alerts',
    name: 'Alerts',
    component: Alerts,
  },
  {
    path: '/collections/:currentTab(trending|minting|own|watchlist)',
    name: 'Collections',
    component: Collections,
  },
  {
    path: '/pulse',
    name: 'Pulse',
    component: Pulse,
  },
  {
    path: '/crates',
    name: 'Crates',
    component: Crates,
  },
  {
    path: '/collections/:contractAddress/:currentTab?',
    props: true,
    name: routesNames.collectionShow,
    component: SingleCollection,
  },
  {
    path: '/wallets',
    redirect: '/feed',
  },
  {
    path: '/feed',
    name: 'Wallets',
    component: FavoriteWallets,
  },
  {
    path: '/wallet/:address?/:currentTab?',
    name: routesNames.walletShow,
    component: SingleWallet,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
  },
  {
    path: '/settings/api',
    name: 'Settings.Api',
    component: ApiTokens,
  },
  {
    path: '/settings/linked-wallets',
    name: 'Settings.LinkedWallets',
    component: LinkedWallets,
  },
  {
    path: '/settings/billing-info',
    name: 'Settings.BillingInfo',
    component: BillingInfo,
  },
  {
    path: '/hooks/discord',
    component: DiscordHook,
  },
  {
    path: '/auth/discord',
    name: 'auth.callbacks.discord',
    component: DiscordHook,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (to.name === from.name && to.name === 'Collections.Show' && to.params.contractAddress === from.params.contractAddress) {
      return;
    }

    if (to.name === from.name && to.name === 'Wallet.Show' && to.params.address === from.params.address) {
      return;
    }

    if (to.hash) {
      return {
        selector: to.hash
      }
    }

    if (savedPosition) {
      return savedPosition
    }

    return { left: 0, top: 0 }
  },
})


export default router
